import { render, staticRenderFns } from "./level-update-modal-levels-example.vue?vue&type=template&id=1d64b7a5&scoped=true&"
import script from "./level-update-modal-levels-example.vue?vue&type=script&lang=ts&"
export * from "./level-update-modal-levels-example.vue?vue&type=script&lang=ts&"
import style0 from "./level-update-modal-levels-example.vue?vue&type=style&index=0&id=1d64b7a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d64b7a5",
  null
  
)

export default component.exports